import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ClientGroupCollectionQuery, ClientGroupCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ClientGroupCollectionQuery)
@Wrapper(ClientGroupCollectionQueryHandlerBase)
export class ClientGroupCollectionQueryHandler {
    public constructor(
        http: Http
    ) { }
}
